import { useEffect } from "react";
import Nav from "@/sections/Nav";
import Footer from "@/sections/Footer";
import UniversalPricing from "@/components/UniversalPricing";
import { Chapter } from "@/components/Chapter";
import { Reveal } from "@/components/Reveal";

export default function PricingPage() {
  useEffect(() => {
    document.title = "Pricing — WSafe AI by WorkSafeAgent";
  }, []);

  return (
    <div className="bg-white text-ink font-sans antialiased min-h-screen">
      <Nav />
      <main className="pt-36 pb-24">
        <div className="mx-auto max-w-[1160px] px-6">
          <Chapter eyebrow="Pricing" title="Simple, per-site, in writing." />
          <UniversalPricing />
          <Reveal delay={0.3}>
            <div className="mt-14 flex flex-wrap gap-4">
              <a
                href="/contact"
                data-testid="pricing-cta-pilot"
                className="rounded-lg bg-safety text-white font-bold px-8 py-4 hover:bg-[#d97c12] transition-colors"
              >
                Request a paid pilot
              </a>
              <a
                href="/contact"
                data-testid="pricing-cta-eval"
                className="rounded-lg border-2 border-navy text-navy font-bold px-8 py-4 hover:bg-navy hover:text-white transition-colors"
              >
                Book a $1,500 compliance evaluation
              </a>
            </div>
          </Reveal>
        </div>
      </main>
      <Footer />
    </div>
  );
}
